module.exports = __webpack_public_path__ + "img/trousers.e8d56280.png";